import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

export const fetchGoogleBooks = createAsyncThunk(
  "googleBooks/fetch",
  async (query) => {
    const response = await axios.get(
      `${BASE_URL}/api/google?query=${encodeURIComponent(query)}`
    );
    return response.data;
  }
);

const googleBookSlice = createSlice({
  name: "googleBooks",
  initialState: {
    googleBooks: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearGoogleBooks: (state) => {
      state.googleBooks = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGoogleBooks.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchGoogleBooks.fulfilled, (state, action) => {
        state.googleBooks = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchGoogleBooks.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearGoogleBooks } = googleBookSlice.actions;

export default googleBookSlice.reducer;
